export const KeyPillarsConfig = [
  {
    icon: 'assets/icons/Browse_Networks.svg',
    title: 'Browse Networks',
    description:
      'Browse gene coexpression networks to see the most highly correlated groups of genes.',
    points: [
      'Browse gene coexpression networks (‘Analyses’) using the left navigation pane.',
      'For each Analysis, the ‘Files’ tab lists different gene coexpression networks built from the same dataset using different parameters (ordered from smallest to largest).',
      'Each folder includes novel network and module visualizations and tables listing module members and statistics (see ‘Gene coexpression analysis navigation’ help video for more info).',
    ],
  },
  {
    icon: 'assets/icons/Discover_Modules.svg',
    title: 'Discover Modules',
    description:
      'Use the Advanced Search to identify gene coexpression modules with desired attributes.',
    points: [
      'Search for modules from datasets and samples with desired attributes that contain one or more genes of interest.',
      'Search for modules that are significantly enriched with a gene set or gene sets of interest.',
      'Or do both!',
      'See ‘Advanced Search’ help video and ‘Sample Queries’ for more info.'
    ],
  },
  {
    icon: 'assets/icons/Reconstruct_Analyses.svg',
    title: 'Reconstruct Analyses',
    description:
      'Inspect code, parameters, and intermediate analysis results for complete reproducibility.',
    points: [
      'Reconstruct gene coexpression analysis results using the interactive workflow visualization tool.',
      'Zoom in or out, drag, or rotate the workflow for clarity.',
      'Preview or download data or code directly from the workflow by hovering over a node.',
      'See ‘Data navigation’ and ‘Gene coexpression analysis navigation’ help videos for more info.',
    ],
  },
  {
    icon: 'assets/icons/Share_Thoughts.svg',
    title: 'Share Thoughts',
    description:
      'Post comments or questions about datasets, networks, modules, and more!',
    points: [
      'Post comments or questions about a Data Collection or Analysis using the ‘Comments’ tab.',
      'Post comments or questions about a specific file by clicking on the comment icon.',
      'Post comments or questions about individual gene coexpression modules on pages of Module Snapshots.',
      'Direct comments to specific users via @mention functionality.',
      'Submit feature requests or bug reports via the ‘Feedback’ link.',
    ],
  },
];
